export default {
  LANDING: {
    HEADER: {
      YOU_ARE_COMPANY: '¿Eres empresa?',
      VIEW_JOB_OFFERS: 'Ver ofertas de empleo',
    },
    META: {
      TITLE: '¡ wokap revoluciona el&nbsp;empleo !',
      TEXT: 'Descarga la app y busca tu próximo trabajo.',
      TEXT_2: 'Deja que miles de empresas te descubran!',
    },
    PRIVACY: { META: { TITLE: 'Política de privacidad' } },
    TERMS: { META: { TITLE: 'Términos y condiciones' } },
    DOWNLOAD_APP: { TITLE: 'Descárgate nuestra app' },
    FOOTER: {
      CONTACT: 'Contacto',
      COPYRIGHT: 'Todos los derechos reservados © wokap',
      PRIVACY: 'Política de privacidad',
      LEGAL: 'Aviso legal',
    },
  },
} as const;
